import React from 'react';
import PropTypes from 'prop-types';
import { component } from 'Helpers/PropTypes';
import { QueryVal } from 'Helpers/Query';
import { useSelectionContextState } from 'Components/UI/ListDetailView/SelectionContext';
import DetailView from './DetailView';
import ListView from './ListView';

const ViewReplace = ({
  DetailViewComponent,
  DetailViewHeaderComponent,
  ListViewListItemComponent,
  ListViewHeaderComponent,
  ListViewListProps,
}) => {
  const { queryValName } = useSelectionContextState();
  const hasSelfLink = !!QueryVal(queryValName);

  if (hasSelfLink) {
    return (
      <DetailView
        DetailComponent={DetailViewComponent}
        HeaderComponent={DetailViewHeaderComponent}
      />
    );
  }

  return (
    <ListView
      ListProps={ListViewListProps}
      HeaderComponent={ListViewHeaderComponent}
      ListItemComponent={ListViewListItemComponent}
    />
  );
};

ViewReplace.defaultProps = {
  ListViewListProps: {},
};

ViewReplace.propTypes = {
  DetailViewComponent: component.isRequired,
  DetailViewHeaderComponent: component.isRequired,
  ListViewHeaderComponent: component.isRequired,
  ListViewListItemComponent: component.isRequired,
  ListViewListProps: PropTypes.object,
};

export default ViewReplace;
